module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "company"
  }, [_c('div', [_vm._v("Copyright © 2021 Zonelink All Rights Reserved.")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#a3a3a3"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备2021134867号")]), _vm._v(" "), _c('a', {
    staticClass: "gongan-div",
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602009867",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.gongan
    }
  }), _vm._v(" "), _c('p', [_vm._v("粤公网安备 44010602009867号")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "icon iconfont icon-kefu"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-label"
  }, [_vm._v("H7 * 12 客服服务")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "icon iconfont icon-zhuanye"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-label"
  }, [_vm._v("T10+ 专业团队")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "icon iconfont icon-anquan"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-label"
  }, [_vm._v("L2+ 数据安全保护")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "icon iconfont icon-xinhao"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-label"
  }, [_vm._v("S4+ 信号加密")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "icon iconfont icon-wending"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-label"
  }, [_vm._v("D365+ 稳定不宕机")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bd0c1fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 329
// module chunks = 1